// extracted by mini-css-extract-plugin
export var activeLink = "Navigation-module--activeLink--dJ+2G";
export var chev = "Navigation-module--chev--AV24l";
export var container = "Navigation-module--container--MAjnn";
export var dropdown = "Navigation-module--dropdown--7CqGD";
export var globe = "Navigation-module--globe--mlCXe";
export var globeText = "Navigation-module--globe--text--XWy5Q";
export var myPages = "Navigation-module--myPages--fah4M";
export var navigationItem = "Navigation-module--navigation-item--W8K5+";